import React from "react";
import PropTypes from "prop-types";

const OneThing = ({ balloon, text, classes }) => (
    <div className="one-thing">
        <div className={`one-thing__balloon ${classes}`}>{balloon}</div>
        <div className="one-thing__text">
            <p className="one-thing__text-one">1 thing</p>
            <p className="one-thing__text-thing">{text}</p>
        </div>
    </div>
);

OneThing.propTypes = {
    balloon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    classes: PropTypes.string.isRequired
};

export default OneThing;



// WEBPACK FOOTER //
// ./src/components/landingPage/OneThing.jsx